import { render } from "./legup-actions.vue?vue&type=template&id=6b651b80&scoped=true"
import script from "./legup-actions.vue?vue&type=script&lang=js"
export * from "./legup-actions.vue?vue&type=script&lang=js"

import "./legup-actions.vue?vue&type=style&index=0&id=6b651b80&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b651b80"]])

export default __exports__